type Constructor<T = Record<any, any>> = new (...args: any[]) => T;
export const AccountMixin = <T extends Constructor>(base: T): T => class extends base {
    constructor(...args: any[]) {
        super(...args);
    }
};
